import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'distance'
})
export class DistancePipe implements PipeTransform {

  isImperial = localStorage.getItem('imperial') && localStorage.getItem('imperial')==='true';

  transform(value: number, args?: string): string {
    if (args==='show') {
      if (!this.isImperial) {
        if (value/1000 < 1) {
          return Math.floor(value).toString() + ' m';
        }
        return (value/1000).toFixed(2).toString() + ' km';

      }
      return (value/1000 * 0.62137).toFixed(2) + ' mi';
    } else if(args ==='showimperial'){
      return (value/1000 * 0.62137).toFixed(2) + ' mi';
    } else if(args ==='showmetric'){
      if (value/1000 < 1) {
          return Math.floor(value).toString() + ' m';
        }
      return (value/1000).toFixed(2).toString() + ' km';
    } else {
      if (!this.isImperial) {
        return (value/1000).toFixed(2);
      }
      return (value/1000 * 0.62137).toFixed(2);
    }

  }

}
